export interface SplashState {
    visible: boolean;
    logoUrl?: string;
}

export const initialSplashState: SplashState = {
    visible: true,
} as const;
